import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import LearningPathComponent from '../components/learning-path.component';
import { selectLMSLearningPathsQueryItems } from '../../../../../../redux/lms/learning-path/selector';
import { lmsLearningPaths } from '../../../../../../redux/lms/learning-path/action';

const ManagementLMSLearningPath = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const params: any = useParams();
  const lmsLearningPathsQuery = useSelector(selectLMSLearningPathsQueryItems);
  const [isQuery, setIsQuery] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [selectLMSLearningPaths, setSelectLMSLearningPaths] = useState<any>({
    title: '',
    description: '',
    mappedTopics: {
      mappedTopicIds: [],
    },
    mediaMappings: {
      mediaFiles: [],
      templates: [],
    },
  });

  const fetchLMSLearningPathsQueryById = () => {
    dispatch(lmsLearningPaths.query({
      url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v1.0/e-applications/lms/learning-paths/query`,
      entity: 'lmsLearningPaths',
      jsonData: {
        records: [
          {
            id: params?.id,
          },
        ],
      },
    })).then(() => {
      setIsQuery(true);
    });
  };

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectLMSLearningPaths({ ...selectLMSLearningPaths, [field]: event });
  };

  useEffect(() => {
    if (params?.id > 0) {
      fetchLMSLearningPathsQueryById();
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (isQuery) {
      setSelectLMSLearningPaths(lmsLearningPathsQuery?.result?.items);
    }
  }, [isQuery]);

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (params?.id > 0) {
      await dispatch(lmsLearningPaths.resetAction({ actionType: 'update' }))
      await dispatch(lmsLearningPaths.update({
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v1.0/e-applications/lms/learning-paths`,
        entity: 'lmsLearningPaths',
        jsonData: {
          records: [selectLMSLearningPaths],
        },
      })).then(() => {
        back();
      });
    } else {
      await dispatch(lmsLearningPaths.resetAction({ actionType: 'create' }))
      await dispatch(lmsLearningPaths.create({
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v1.0/e-applications/lms/learning-paths`,
        entity: 'lmsLearningPaths',
        jsonData: {
          records: [selectLMSLearningPaths],
        },
      })).then(() => {
        back();
      });
    }
  };

  const back = () => {
    navigate('/management/e-applications/lms/learning-paths');
  };

  return (
    <>
      {lmsLearningPathsQuery?.isLoading ? (
        <PageLoader />
      ) : (
        <LearningPathComponent
          handleInnerFormChange={handleInnerFormChange}
          selectLMSLearningPaths={selectLMSLearningPaths}
          back={back}
          handleFormSubmit={handleFormSubmit}
        />
      )}
    </>
  );
};

export default ManagementLMSLearningPath;
